import {
  Component,
  OnInit,
  ViewEncapsulation,
  Output,
  Input,
  EventEmitter,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'postcode-map-london',
  templateUrl: './postcode-map-london.component.html',
  styleUrls: ['./postcode-map-london.component.css'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class PostcodeMapLondonComponent implements OnInit {
  _datas: string[] = [];
  @Output() londonCodeChange: EventEmitter<string[]>;
  @Input('datas')
  public set datas(value: string[]) {
    if (!value) {
      value = [];
    }
    this._datas = value;
    this.londonCodeChange.emit(value);
  }
  public get datas(): string[] {
    return this._datas;
  }

  constructor() {
    this.londonCodeChange = new EventEmitter<string[]>();
  }

  ngOnInit() {}

  selectAreas(allAreas: boolean) {
    if (!allAreas) {
      this.datas = [];
    } else {
      // read all <text nodes and extract the area codes
      var london = document.getElementById('tabLondonPostcodes');
      if (london) {
        var text = Array.from(london.getElementsByTagName('text'));

        var codes = text.map((x) => {
          return x.innerHTML;
        });

        // fill the datas array with the codes
        this.datas = codes;
      }
    }
  }

  SelectCode(code: string) {
    var indexOf = this.datas.indexOf(code);
    if (indexOf < 0) {
      this.datas.push(code);
    } else {
      this.datas.splice(indexOf, 1);
    }
  }

  IsSelected(code) {
    return this.datas.indexOf(code) >= 0;
  }
}
